import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
    const userEmail = localStorage.getItem("userEmail");
    return userEmail ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;
